import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const RotatingBanner = () => {
  const banners = [
    {
      id: 1,
      title: "Transforming Ideas Into Digital Excellence",
      subtitle: "Transform your business with cutting-edge technology solutions"
    },
    {
      id: 2,
      title: "Leading Technology Solutions Provider",
      subtitle: "Empowering businesses worldwide with innovative digital solutions"
    },
    {
      id: 3,
      title: "Building Tomorrow's Technology Today",
      subtitle: "From mobile apps to AI solutions - we deliver excellence"
    },
    {
      id: 4,
      title: "Your Trusted Digital Transformation Partner",
      subtitle: "Expert team delivering world-class technology solutions"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [banners.length]);

  return (
    <div className="relative w-full flex flex-col items-center justify-center">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="text-center px-4"
        >
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            {banners[currentIndex].title}
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto drop-shadow-md">
            {banners[currentIndex].subtitle}
          </p>
        </motion.div>
      </AnimatePresence>

      {/* Dots indicator */}
      <div className="mt-8 flex space-x-3">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentIndex
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`Go to banner ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default RotatingBanner;
